export const MarketType = {
    Spot: 'spot',
    Derivative: 'derivative',
};
// Trailing Arithmetic
export const GridStrategyType = {
    Geometric: 'geometric',
    Arithmetic: 'arithmetic',
    Perpetual: 'perpetual',
    // Trailing Arithmetic
};
